module.exports = __webpack_public_path__ + "img/tongdian.1fab66a1.jpg";